var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolderHomeModern(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#folder-home-modern_svg__clip0_1152_7877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 8.494a2.572 2.572 0 00-.962-2.004 2.192 2.192 0 01-1.107 1.042 2.134 2.134 0 00-.98-4.04 1.3 1.3 0 00-.256.017c.309.662.468 1.385.465 2.116v.144a5.139 5.139 0 00-10.27-.016v-.128a5.299 5.299 0 01.464-2.132 3.796 3.796 0 00.45 7.566h9.692A2.55 2.55 0 0016 8.494z",
    fill: "#1BBED0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.992 1.778a4.136 4.136 0 104.156 4.136 4.147 4.147 0 00-4.156-4.136zm0 7.741a3.606 3.606 0 113.61-3.605 3.614 3.614 0 01-3.61 3.605z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.884 3.764a.61.61 0 00-.609.609v3.304a.61.61 0 001.218 0V6.97H8.68a1.604 1.604 0 100-3.207m-.016 2.069h-1.17v-.947H8.68a.483.483 0 01.481.48.494.494 0 01-.497.466",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "folder-home-modern_svg__clip0_1152_7877"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(0 .8)",
    d: "M0 0h16v10.258H0z"
  })))));
}
export default SvgFolderHomeModern;